import { ReactComponent as PLUSCIRCLE } from "../../../assets/PlusInCircleIcon.svg"
import { P } from "../../../auth/permissions"
import { Authorized } from "../../../components/authentication/Authorized"
import { Tour, TourStop, TourWeekday, TOUR_WEEKDAYS } from "../types"
import TourStopCard from "./TourStopCard"

type TourWeekBoardType = {
    tour: Tour
    otherTours: Tour[]
    canEdit: boolean
    onAddStop: (weekday: TourWeekday) => void
    onRemoveStop: (stopId: string) => void
    onMoveUp: (stopId: string) => void
    onMoveDown: (stopId: string) => void
    onChangeWeekday: (stopId: string, weekday: TourWeekday) => void
    onMoveToTour: (stopId: string, tourId: string, weekday: TourWeekday) => void
}

export default function TourWeekBoard(props: TourWeekBoardType) {
    const stopsForDay = (weekday: TourWeekday): TourStop[] => props.tour.stops.filter((stop) => stop.weekday === weekday).sort((a, b) => a.sortOrder - b.sortOrder)

    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-5 gap-3 h-full min-h-0">
            {TOUR_WEEKDAYS.map((day) => {
                const dayStops = stopsForDay(day.value)
                return (
                    <div key={day.value} className="bg-gray-50 rounded-default shadow-inner flex flex-col min-h-[16rem] overflow-hidden">
                        <div className="flex items-center justify-between px-3 py-2 border-b bg-white rounded-t-default">
                            <div>
                                <p className="font-semibold uppercase tracking-wide text-sm">{day.label}</p>
                                <p className="text-xs text-gray-400">{dayStops.length} Objekte</p>
                            </div>
                            {props.canEdit && (
                                <Authorized allOf={[P.termine_management]}>
                                    <PLUSCIRCLE className="w-7 h-7 cursor-pointer" onClick={() => props.onAddStop(day.value)} />
                                </Authorized>
                            )}
                        </div>
                        <div className="flex flex-col gap-2 p-2 overflow-y-auto grow">
                            {dayStops.length === 0 && <p className="text-center text-gray-300 text-xs uppercase font-bold py-6">Keine Objekte</p>}
                            {dayStops.map((stop) => (
                                <TourStopCard
                                    key={stop._id}
                                    stop={stop}
                                    otherTours={props.otherTours}
                                    canEdit={props.canEdit}
                                    onRemove={() => props.onRemoveStop(stop._id)}
                                    onMoveUp={() => props.onMoveUp(stop._id)}
                                    onMoveDown={() => props.onMoveDown(stop._id)}
                                    onChangeWeekday={(weekday) => props.onChangeWeekday(stop._id, weekday)}
                                    onMoveToTour={(tourId, weekday) => props.onMoveToTour(stop._id, tourId, weekday)}
                                />
                            ))}
                        </div>
                    </div>
                )
            })}
        </div>
    )
}
